// extracted by mini-css-extract-plugin
export default {"root":"roles_header___root___b22ebe61","scrollWrapper":"roles_header___scrollWrapper___ba4e1665","headersRow":"roles_header___headersRow___b119ab38"};